/**
 * Stats Overview Component
 *
 * Key metrics in compact card format
 */

import './StatsOverview.css';

interface Stats {
  totalWorkouts: number;
  avgDuration: number;
}

interface StatsOverviewProps {
  stats: Stats;
}

export function StatsOverview({ stats }: StatsOverviewProps): JSX.Element {
  return (
    <div className="stats-overview stats-overview--compact">
      <div className="stat-card stat-card--small">
        <div className="stat-card__icon">💪</div>
        <div className="stat-card__value">{stats.totalWorkouts}</div>
        <div className="stat-card__label">Total Workouts</div>
      </div>

      <div className="stat-card stat-card--small">
        <div className="stat-card__icon">⏱</div>
        <div className="stat-card__value">{stats.avgDuration}m</div>
        <div className="stat-card__label">Avg Duration</div>
      </div>
    </div>
  );
}
